<h2 mat-dialog-title>
  <mat-icon>apartment</mat-icon>
  Afdelingsbegrænsning
  @if (user) {
    for {{ user.firstName }} {{ user.lastName }}
  }
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
@if (departmentRestrictionFormGroup) {
  <form [formGroup]="departmentRestrictionFormGroup" (ngSubmit)="saveAndClose()">
    <mat-dialog-content>
      @if (user) {
        <adm-drag-drop-relation
          [dragDropType]="dragDropTypeEnum.DepartmentRestriction"
          [leftSideHeader]="'Afdelinger'"
          [rightSideHeader]="'Afdelingsbegrænsning for ' + user.firstName + ' ' + user.lastName"
          [element]="user"
          [leftSideList]="filteredDepartments"
          [rightSideList]="selectedDepartments"
          [rightFilteredList]="filteredSelectedDepartments"
          [title]="''"
          (dropEvent)="onDrop($event)"
          (update)="onUpdate($event)"
          (searchEvent)="onSearch($event)" />
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      @if (user && user.identifier) {
        <div class="unit-identifier">
          <span>Bruger ID:</span>
          {{ user.id }}
        </div>
      }
      @if (!saved) {
        <button type="button" mat-button mat-dialog-close>Annuller</button>
      }
      @if (saved) {
        <button type="button" mat-button (click)="close()">Luk</button>
      }
      <button
        class="actions__button"
        type="submit"
        mat-flat-button
        color="primary"
        [disabled]="saving || departmentRestrictionFormGroup.invalid || !departmentRestrictionFormGroup.dirty"
        [class.spinner]="saving">
        Gem
      </button>

      <input type="hidden" formControlName="departmentNames" />
    </mat-dialog-actions>
  </form>
}
